import * as Sentry from "@sentry/react";
import { sanitizeLogContext } from "./logger";

type ErrorContext = Record<string, string | number | boolean | null | undefined>;

let initialized = false;

export function sanitizeErrorContext(context: ErrorContext = {}) {
  return sanitizeLogContext(context);
}

export function initDashboardErrorTracking() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || initialized) return false;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    maxBreadcrumbs: 50,
    release: import.meta.env.VITE_APP_VERSION,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
    sendDefaultPii: false,
  });
  initialized = true;
  return true;
}

export function captureDashboardError(error: unknown, context: ErrorContext = {}) {
  if (!initialized) return false;
  const sanitized = sanitizeErrorContext(context);
  const userId = sanitized.userId ?? sanitized.operatorId ?? sanitized.actorId;
  const traceId = sanitized.traceId;
  if (userId !== undefined) {
    Sentry.setUser({ id: String(userId) });
  }
  if (traceId !== undefined) {
    Sentry.setTag("trace_id", String(traceId));
  }
  Sentry.addBreadcrumb({
    category: "dashboard.error",
    level: "error",
    message: error instanceof Error ? error.message : "dashboard_error",
    data: sanitized,
  });
  Sentry.setContext("dashboard", sanitized);
  Sentry.captureException(error);
  return true;
}
